export default __webpack_public_path__ + "static/media/ic-upload.5ebfa60b.svg";